"use client";

import Image from "next/image";
import { Dialog } from "@hubble/web";
import { useTranslations } from "i18n";
import { handleContentfulLoader } from "utils/images/contentfulLoader";

const DownloadAppModal = () => {
  const t = useTranslations("homepage");

  return (
    <Dialog.Container>
      <Dialog.Header>
        <p className="text-center text-xl leading-8 font-semibold text-[#010304]">
          {t("heroModalTitleText")}
        </p>
      </Dialog.Header>

      <Dialog.Content>
        <div className="flex w-full items-center justify-center">
          <Image
            src="https://cdn.builder.io/api/v1/image/assets%2F1b77ce3a269a43e985e77f3d65f715ba%2F5183b21b423a4cec830822e6ec08cbe6?quality=100"
            alt="qr"
            height={220}
            width={448}
            loader={handleContentfulLoader}
          />
        </div>
      </Dialog.Content>
    </Dialog.Container>
  );
};

export default DownloadAppModal;
